import { InlineTableData } from '@morningstar/shared/models';

export interface MeetingAttendee extends InlineTableData {
  meetingId: number;
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  unexpected: boolean;
  keyholder: boolean;
  pSeq?: number | null;
  arrivalDate?: Date | null;
  arrived: boolean;
}